import { motion } from "framer-motion";
import { ArrowDown, ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import OrbCanvas from "@/components/OrbCanvas";
import { EASE } from "@/components/Shared";

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative flex min-h-[100svh] items-center overflow-hidden"
    >
      <div className="absolute inset-0 opacity-60 md:left-[35%] md:opacity-100" aria-hidden="true">
        <OrbCanvas />
      </div>
      <div
        className="pointer-events-none absolute inset-x-0 bottom-0 h-36 bg-gradient-to-b from-transparent to-ink"
        aria-hidden="true"
      />

      <div className="container-x relative z-10 flex min-h-[100svh] flex-col justify-center pb-24 pt-32">
        <motion.p
          data-testid="hero-eyebrow"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
          className="eyebrow flex items-center gap-3"
        >
          <span className="relative flex h-2 w-2" aria-hidden="true">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-cy opacity-60" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-cy" />
          </span>
          Welcome To BT Design
        </motion.p>

        <h1
          data-testid="hero-headline"
          className="mt-7 font-grotesk text-[clamp(2.7rem,7vw,5.6rem)] font-bold leading-[1.05] tracking-tight text-txt"
        >
          {["Technology That", "Moves Your Business"].map((line, i) => (
            <span key={line} className="block overflow-hidden pb-1">
              <motion.span
                className="block"
                initial={{ y: "112%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1, delay: 0.25 + i * 0.13, ease: EASE }}
              >
                {line}
              </motion.span>
            </span>
          ))}
          <span className="block overflow-hidden pb-2">
            <motion.span
              className="grad-text block"
              initial={{ y: "112%" }}
              animate={{ y: 0 }}
              transition={{ duration: 1, delay: 0.51, ease: EASE }}
            >
              Forward.
            </motion.span>
          </span>
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.75, ease: EASE }}
          className="mt-7 max-w-xl text-base leading-relaxed text-sub sm:text-lg"
        >
          We build modern websites, deliver practical IT solutions, and help
          businesses turn ideas into powerful digital experiences.
        </motion.p>

        <motion.div
          className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.9, ease: EASE }}
        >
          <button
            type="button"
            data-testid="hero-primary-cta"
            onClick={() => navigate("/contact")}
            className="btn-primary justify-center"
          >
            Let's Build Something
            <ArrowUpRight className="h-4 w-4" strokeWidth={2.5} />
          </button>
          <button
            type="button"
            data-testid="hero-secondary-cta"
            onClick={() => navigate("/services")}
            className="btn-ghost justify-center"
          >
            Explore Our Services
            <ArrowDown className="h-4 w-4" strokeWidth={2.5} />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
